module.exports = __webpack_public_path__ + "static/media/Fraser Anderson.fdd0a35c.png";